module.exports = __webpack_public_path__ + "exo-latin-100.7a962253b4221d26fc52.woff";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-100.woff
// module id = ../../../../typeface-exo/files/exo-latin-100.woff
// module chunks = styles